import api from '../../../api/clinique/_liste_attente.js';

const state = () => ({
    queues: [],
});

const getters = {
    queues: (state) => {
        return state.queues;
    },
};

const mutations = {
    SET_QUEUES(state, queues) {
        state.queues = queues;
    },
};

const actions = {
    fetchQueues({ commit }) {
        return new Promise((resolve, reject) => {
            api.fetchQueues().then((response) => {
                commit("SET_QUEUES", response);
                resolve(response);
            }, error => {
                reject(error);
            });
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
